'use strict'

const INSTRUMENT_TESTS_REQUEST= "INSTRUMENT_TESTS_REQUEST";
const INSTRUMENT_TESTS_SUCCESS= "INSTRUMENT_TESTS_SUCCESS";
const INSTRUMENT_TESTS_FAILURE= "INSTRUMENT_TESTS_FAILURE";
const INSTRUMENT_TESTS_DEVICE_STATE_ADD = 'INSTRUMENT_TESTS_DEVICE_STATE_ADD';
const INSTRUMENT_TESTS_DEVICE_STATE_REMOVE = 'INSTRUMENT_TESTS_DEVICE_STATE_REMOVE';
const MODEL_DXA5000 = "DXA5000";

export {
    INSTRUMENT_TESTS_REQUEST,
	INSTRUMENT_TESTS_SUCCESS,
	INSTRUMENT_TESTS_FAILURE,
	INSTRUMENT_TESTS_DEVICE_STATE_ADD,
	INSTRUMENT_TESTS_DEVICE_STATE_REMOVE,
	MODEL_DXA5000
}